import { ChevronDownIcon } from '@heroicons/react/24/solid'
import { useEffect, useState } from 'react'

type Props = {
  open?: boolean
  title: React.ReactNode | string
  content: React.ReactNode | string | string[]
  clickedCallback?: () => void
  isLast?: boolean
  isFirst?: boolean
  className?: string
  fitTitle?: boolean
}

const Section: React.FC<Props> = ({ open, title, content, clickedCallback, className = '', fitTitle = false }) => {
  const [internalOpen, setInternalOpen] = useState<boolean>(open || false)

  useEffect(() => {
    if (open !== undefined) {
      setInternalOpen(open)
    }
  }, [open])

  const click = () => {
    if (open !== undefined) {
      clickedCallback && clickedCallback()
    } else {
      setInternalOpen(!internalOpen)
    }
  }

  return (
    <div className={` border-t border-white overflow-hidden h-fit ${className}`}>
      <div className={`flex items-center title bg-light py-1 px-2 ${fitTitle ? 'h-fit' : 'h-7'} cursor-pointer w-full`} onClick={click}>
        <div className="w-11/12 truncate font-bold">{title}</div>
        <div className="w-1/12 flex justify-end">
          <ChevronDownIcon className={`w-4 transition-all ${internalOpen && 'rotate-180'}`} />
        </div>
      </div>
      <div className={`content transition-all px-2 ${internalOpen ? 'max-h-fit pb-1' : 'max-h-0'}`}>
        {typeof content === 'string' ? <div className=" text-xs">{content}</div> : content}
      </div>
    </div>
  )
}

export default Section
